import type { DriveStep } from "driver.js";
import { ONBOARDING_IDS } from "../constants";

export const teamPlayersSteps: DriveStep[] = [
    {
        element: `#${ONBOARDING_IDS.PLAYERS_SORT}`,
        popover: {
            title: "Sort & Filter Players",
            description:
                "Sort the team's roster alphabetically or by KPI score, and toggle direction to rank from top to bottom. " +
                "The list includes both field players and goalkeepers.",
            side: "bottom",
            align: "start",
        },
    },
    {
        element: `#${ONBOARDING_IDS.TEAM_PLAYERS_LIST}`,
        popover: {
            title: "Team Roster",
            description:
                "Every player in the team's tournament squad is shown here with their position and KPI score. " +
                "Click any player card to open their individual profile with detailed match-by-match statistics.",
            side: "top",
            align: "center",
        },
    },
];
